import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useParams, useNavigate } from "react-router";
import axios from "axios";
import "../css/ReporteAula.css";

const ReporteAula = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const URL_API = process.env.REACT_APP_URL_API || 'http://localhost:5000';

  const [formattedData, setFormattedData] = React.useState([]);
  const [aula, setAula] = React.useState(id || ""); // Inicializamos como cadena vacía si no hay id

  React.useEffect(() => {
    if (id) {
      axios.get(URL_API + `estadisticas-aula/${id}`).then((res) => {
        setFormattedData(
          res.data.map((item) => ({
            dia: item.dia,
            cantidad: item.cantidad === "No se uso" ? 0 : item.cantidad,
          }))
        );
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  console.log(formattedData);

  // Opciones para el select de aulas
  const aulas = [
    { value: "1", label: "Aula 11" },
    { value: "2", label: "Aula 12" },
    { value: "3", label: "Aula 13" },
    { value: "4", label: "Aula 14" },
    { value: "5", label: "Aula 15" },
    { value: "6", label: "Aula 16" },
    { value: "7", label: "Aula 17" },
    { value: "8", label: "Aula SUMPA" },
    { value: "9", label: "Aula SAVPA" },
  ];

  return (
    <div className="container">
      <div className="header">
        <div className="title-section">
          <h1 className="title">Uso del Aula en los Últimos 30 Días</h1>
        </div>
        <div className="filter-section">
          <div className="input-group">
            <label htmlFor="aula-select">Aula a consultar</label>
            <select
              id="aula-select"
              className="filter-input"
              value={aula}
              onChange={(e) => setAula(e.target.value)}
            >
              <option value="">Seleccione un aula</option>
              {aulas.map((aulaOption) => (
                <option key={aulaOption.value} value={aulaOption.value}>
                  {aulaOption.label}
                </option>
              ))}
            </select>
          </div>
          <button onClick={() => navigate(`/reporte/${aula}`)} className="consult-btn">
            Consultar
          </button>
        </div>
      </div>

      {formattedData.length === 0 ? (
        <p className="no-data">No hay registros</p>
      ) : (
        <ResponsiveContainer width="80%" height={300} className="chart-container">
          <BarChart
            data={formattedData}
            margin={{ top: 20, right: 30, left: 30, bottom: 50 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="dia"
              tick={{ textAnchor: "middle", fontSize: 14 }}
              interval={0}
            />
            <YAxis
              domain={[0, "auto"]}
              tick={{ textAnchor: "middle", fontSize: 14 }}
            />
            <Tooltip contentStyle={{ textAlign: "center" }} />
            <Legend wrapperStyle={{ textAlign: "center" }} />
            <Bar dataKey="cantidad" fill="#00BF63" barSize={50} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default ReporteAula;